export enum HotjarCustomEvent {
    RecordClass = 'record_class',
}

export const addHotjarCustomEvent = (customEvent: HotjarCustomEvent) => {
    if (typeof hj !== 'function') {
        return;
    }
    hj('event', customEvent);
};
